import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ReconciliationReportData} from "./reconciliation-report.data";

@Injectable()
export class ReconciliationReportModel extends ReportModel<ReconciliationReportData> {
    constructor(injector: Injector) {
        super(injector, ReconciliationReportData);
    }

}
